"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TokenValidator = _interopRequireDefault(require("../../../core/TokenValidator"));

var _FetchHelper = _interopRequireDefault(require("../../../core/FetchHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CourseService =
/*#__PURE__*/
function () {
  function CourseService(url, kundennummer, obtainTokenMethod, removeTokenMethod, tokenMethod, trainingCenterId, modules) {
    _classCallCheck(this, CourseService);

    this.url = url;
    this.kundennummer = kundennummer;
    this.obtainTokenMethod = obtainTokenMethod;
    this.removeTokenMethod = removeTokenMethod;
    this.trainingCenterId = trainingCenterId;
    this.modules = modules;
  }

  _createClass(CourseService, [{
    key: "getCourse",
    value: function getCourse(courseId) {
      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      if (!this.modules || !this.modules[62] || this.modules[62] && token) {
        _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId,
          "kundennummer": this.kundennummer
        }
      };
      return _FetchHelper["default"].get(this.url + "/course/" + courseId, options);
    }
  }, {
    key: "getCourseProgress",
    value: function getCourseProgress(courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/course/progress/" + courseId, options);
    }
  }, {
    key: "getBookableCourses",
    value: function getBookableCourses(categoryId) {
      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      if (!this.modules || !this.modules[62] || this.modules[62] && token) {
        _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId,
          "kundennummer": this.kundennummer
        }
      };

      if (categoryId !== undefined) {
        return _FetchHelper["default"].get(this.url + "/course/catalogue?categoryId=" + categoryId, options);
      } else {
        return _FetchHelper["default"].get(this.url + "/course/catalogue", options);
      }
    }
  }, {
    key: "searchForBookableCourses",
    value: function searchForBookableCourses(search) {
      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      if (!this.modules || !this.modules[62] || this.modules[62] && token) {
        _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId,
          "kundennummer": this.kundennummer
        }
      };

      if (search !== undefined) {
        return _FetchHelper["default"].get(this.url + "/course/catalogue/search?query=" + search, options);
      }
    }
  }, {
    key: "getAssignedCourses",
    value: function getAssignedCourses(selfBooking) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/course/assigned" + (selfBooking ? "?selfBooking=" + selfBooking : ""), options);
    }
  }, {
    key: "getAssignedCoursesPages",
    value: function getAssignedCoursesPages(queryOptions, page, pageSize) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId,
          "kundennummer": this.kundennummer
        },
        body: {
          meta: {
            page: page,
            pageSize: pageSize
          },
          options: queryOptions
        }
      };
      return _FetchHelper["default"].post(this.url + "/course/assigned/paginate", options);
    }
  }, {
    key: "getActorSpeakerCourses",
    value: function getActorSpeakerCourses() {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/course/hosting", options);
    }
  }, {
    key: "getCoursesCalendar",
    value: function getCoursesCalendar(queryOptions) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var postWithQueryOptions = queryOptions !== null && queryOptions !== undefined;
      var options = postWithQueryOptions ? {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        },
        body: {
          options: queryOptions
        }
      } : {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };

      if (postWithQueryOptions) {
        return _FetchHelper["default"].post(this.url + "/course/calendar", options);
      }

      return _FetchHelper["default"].get(this.url + "/course/calendar", options);
    }
  }, {
    key: "getCourseUserInformation",
    value: function getCourseUserInformation(courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/json",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].get(this.url + "/userinformation/" + courseId, options);
    }
  }, {
    key: "getCertificate",
    value: function getCertificate(courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "Content-Type": "application/pdf",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        }
      };
      return _FetchHelper["default"].getBlob(this.url + "/courseuserstatus/print/certificate/" + courseId, options);
    }
  }, {
    key: "uploadCertificate",
    value: function uploadCertificate(file, courseId, information) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var formData = new FormData();
      formData.append("uploadedFile", file);
      formData.append("fileName", file.name);

      if (information) {
        formData.append("title", information.title);
        formData.append("comment", information.comment);
      }

      var options = {
        headers: {
          "enctype": "multipart/form-data",
          "authorization": token,
          "academymaker-training-center": this.trainingCenterId
        },
        body: formData
      };
      return _FetchHelper["default"].post(this.url + "/courseuserstatus/save/certificate/" + courseId, options);
    }
  }, {
    key: "checkSendCertificate",
    value: function checkSendCertificate(courseId) {
      _TokenValidator["default"].validate(this.obtainTokenMethod, this.removeTokenMethod);

      var token;

      if (this.obtainTokenMethod !== undefined && typeof this.obtainTokenMethod === 'function') {
        token = this.obtainTokenMethod();
      } else {
        token = localStorage.getItem('authentication');
      }

      var options = {
        headers: {
          "authorization": token
        }
      };
      return _FetchHelper["default"].put(this.url + "/course/" + courseId + "/certificate", options);
    }
  }]);

  return CourseService;
}();

exports["default"] = CourseService;